import { render, staticRenderFns } from "./activity-pk-box.vue?vue&type=template&id=7351b6d4&scoped=true&"
import script from "./activity-pk-box.vue?vue&type=script&lang=js&"
export * from "./activity-pk-box.vue?vue&type=script&lang=js&"
import style0 from "./activity-pk-box.vue?vue&type=style&index=0&id=7351b6d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7351b6d4",
  null
  
)

export default component.exports